export enum MODAL_TYPE {
  EDIT = 'edit',
  CREATE = 'create',
}

export enum MODEL_TYPE {
  VIEW = 'view',
  FORM = 'forms',
  VIEW_ACTION = 'view_action',
  FORM_ACTION = 'form_action',
  FORM_CONFIG_LIST_CONTROL_ELEMENT_ACTION = 'form_config_list_control_element_action',
  COLUMN = 'column',
  FIELD = 'field',
  GANTT = 'gantt',
  LIST_CONTROL = 'listControl',
  GANTT_ACTION_RESOURCE = 'gantt_action_resource',
  GANTT_ACTION_TIMELINES = 'gantt_action_timelines',
  GANTT_SEGMENT = 'gantt_segment',
  DISPLAY_RULES = 'display_rules',
  TOOLTIP = 'tooltip',
  BAR_CHART_COLUMN = 'bar_chart_column',
  TIMELINE_OBJECT_Y_COLUMN = 'timeline_object_y_column',
  TIMELINE_OBJECT_X_COLUMN = 'timeline_object_x_column',
  TIMELINE_OBJECT_Y_ACTION = 'timeline_object_y_action',
  TIMELINE_OBJECT_X_ACTION = 'timeline_object_x_action',
  CONTEXT_MENU_POINT_ACTION = 'context_menu_point_action',
  TIMELINE_ACTION = 'timeline_action',
  TOOLTIP_ACTION = 'tooltip_action',
}

export enum GANTT_PARTS {
  BACKLOG = 'backlog',
}

export enum ACTION_CODE {
  OPEN_FORM_MODEL = 'open_form_model',
  SET_FIELD_VALUE = 'set_field_value',
  SET_VARIABLE_VALUE = 'set_variable_value',
  OPEN_ANOTHER_FORM_MODEL = 'open_another_form_model',
  CHANGE_VARIABLE_VALUE = 'change_variable_value',
  OPEN_CONTEXT_MENU = 'open_context_menu',
  OPEN_TOOLTIP = 'open_tooltip',
  OPEN_NEW_LINE = 'open_new_line',
  EXECUTE_COMMAND = 'execute_command',
  DELETE_OBJECT = 'delete_object',
  DOWNLOAD_FILE = 'download_file',
  PREVIEW_FILE = 'preview_file',
  POST_VALUE = 'post_value',
  MODIFY_DATA = 'modify_data',
  SET_DATA = 'set_data',
}

export const actionsWithFirstPriority = [ACTION_CODE.SET_VARIABLE_VALUE]

export enum EVENT_CODE {
  ON_ROW_CLICK = 'on_row_click',
  ON_ROW_CREATE = 'on_row_create',
  ON_ROW_EDIT = 'on_row_edit',
  ON_ROW_ADDITIONAL_BUTTON_CLICK = 'on_row_additional_button_click',
  ON_ROW_DOWNLOAD_BUTTON_CLICK = 'on_row_download_button_click',
  ON_ROW_PREVIEW_BUTTON_CLICK = 'on_row_preview_button_click',
  ON_COLUMN_RIGHT_CLICK = 'on_column_right_click',
  ON_ROW_RIGHT_CLICK = 'on_row_right_click',
  ON_ROW_DELETE_BUTTON_CLICK = 'on_row_delete_button_click',
  ON_HEADER_TOOLTIP = 'on_header_tooltip',
  ON_ROW_TOOLTIP = 'on_row_tooltip',
  ON_CELL_TOOLTIP = 'on_cell_tooltip',
  ON_BUTTON_PRESS = 'on_button_press',
  CHANGE_FIELD_VALUE = 'change_field_value',
  ON_ROW_SELECTION = 'on_row_selection',
  TIME_LINE_ON_CREATE_BUTTON_CLICK = 'timeline_on_create_button_click',
  ON_CELL_RIGHT_CLICK = 'on_cell_right_click',
  ON_CELL_VALUE_RIGHT_CLICK = 'on_cell_value_right_click',
  ON_CELL_VALUE_LEFT_CLICK = 'on_cell_value_left_click',
  ON_CELL_VALUE_MOUSE_OVER = 'on_cell_value_mouse_over',
  ON_ROW_MOUSE_OVER = 'on_row_mouse_over',
  AFTER_LOAD_DATA = 'after_load_data',
  ON_INIT_FORM = 'on_init_form',
  BEFORE_LOAD_DATA = 'before_load_data',
  ON_CONTEXT_MENU_POINT_CLICK = 'on_context_menu_point_click',
  ON_VARIABLE_CHANGE = 'on_variable_change',
  ON_ROW_DOUBLE_LEFT_CLICK = 'on_row_double_left_click',
  ON_CELL_VALUE_DOUBLE_LEFT_CLICK = 'on_cell_value_double_left_click',
  ON_DRAG_START = 'on_drag_start',
  ON_DROP = 'on_drop',
  ON_INIT_TOOLTIP = 'on_init_tooltip',
}

export enum EVENT_CODE_GANTT {
  ON_ROW_CLICK = 'on_row_click',
  ON_CELL_CLICK = 'on_cell_click',
  ON_BAR_CLICK = 'on_bar_click',
  ON_SEGMENT_CLICK = 'on_segment_click',
  ON_BAR_RIGHT_CLICK = 'on_bar_right_click',
  ON_ROW_RIGHT_CLICK = 'on_row_right_click',
  ON_HEADER_RIGHT_CLICK = 'on_header_right_click',
  ON_TOOLTIP_HEADER = 'on_tooltip_header',
  ON_TOOLTIP_ROW = 'on_tooltip_row',
  ON_TOOLTIP_BAR = 'on_tooltip_bar',
  ON_TOOLTIP_SEGMENT = 'on_tooltip_segment',
  ON_SEGMENT_RESIZE_IN_TIMELOG = 'on_segment_resize_in_timelog',
  ON_SEGMENT_RESIZE_IN_BACKLOG = 'on_segment_resize_in_backlog',
  ON_SEGMENT_MOVE_IN_TIMELOG = 'on_segment_move_in_timelog',
  ON_SEGMENT_MOVE_IN_BACKLOG = 'on_segment_move_in_backlog',
  ON_SEGMENT_MOVE_FROM_TIMELOG_TO_BACKLOG = 'on_segment_move_from_timelog_to_backlog',
  ON_SEGMENT_MOVE_FROM_BACKLOG_TO_TIMELOG = 'on_segment_move_from_backlog_to_timelog',
}
